import moment from "moment";
import DateTime from "./DateTime";

export default abstract class AuditableDocument {
	public static sanitise(input: string): string {
		return input.replace(new RegExp(/[_ -]/, "gi"), "");
	}

	public static expiryIsValid(date: string): boolean {
		return moment(date).isAfter(moment());
	}

	public static expiryIsInvalid(date: string): boolean {
		return !AuditableDocument.expiryIsValid(date);
	}

	public static formatExpiry(
		input: string,
		requiredLength: 7 | 10 = 7
	): string {
		const sanitisedInput = AuditableDocument.sanitise(input);
		if (sanitisedInput.length < requiredLength) {
			return "";
		}

		const inputParts = sanitisedInput.split("/");

		const yr = inputParts.length === 3 ? inputParts[2] : inputParts[1];
		const month = inputParts.length === 3 ? inputParts[1] : inputParts[0];
		const date = inputParts.length === 3 ? inputParts[0] : "01";

		const expiry = `${yr}-${month}-${date}`;

		if (!moment(expiry).isValid()) {
			throw new Error("Invalid date format.");
		}

		if (inputParts.length === 3) {
			return expiry;
		}

		return moment(expiry)
			.add(1, "month")
			.add(-1, "day")
			.format(DateTime.DEFAULT_DATE_FORMAT);
	}
}
